/**
 * A count of the Agent runs panel's events, per QueryClient and project:
 * each panel GET that starts and each panel write that settles.
 *
 * The backend PUT commits, then answers with a panel from a fresh GitLab
 * scan, so answers can arrive out of commit order. A pause stores
 * the panel its PUT answered only while this count has not moved since the
 * PUT was sent; otherwise a newer read or commit may exist, and the panel
 * refetches instead.
 */

import type { QueryClient } from '@tanstack/react-query';

const epochs = new WeakMap<QueryClient, Map<string, number>>();

export function panelEpoch(client: QueryClient, projectId: string): number {
  return epochs.get(client)?.get(projectId) ?? 0;
}

export function bumpPanelEpoch(client: QueryClient, projectId: string): void {
  const counts = epochs.get(client) ?? new Map<string, number>();
  counts.set(projectId, (counts.get(projectId) ?? 0) + 1);
  epochs.set(client, counts);
}
